export function isViewingApplicantDeleting({ applicant, deletingApplicantId }) {
  return String(applicant.id) === String(deletingApplicantId)
}
